import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";
const Missionnmole = () => {
  return (
    <>
      <Header />
      <Breadcrumb pageTitle="Mission N Mole" breadcrumbName="Mission N Mole" />

      <div className="container toppad-30">
        <div className="row">
          <div className="col-md-12">
            <center>
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/AFGJI/public/Images/Mission-NMOLE-1.jpg"
                  alt="AFGJI"
                  className="img-responsive"
                />
              </LazyLoad>
            </center>
          </div>
          <div className="clr10"></div>
          <div className="col-md-12">
            <center>
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/AFGJI/public/Images/Mission-NMOLE-2.jpg"
                  alt="AFGJI"
                  className="img-responsive"
                />
              </LazyLoad>
            </center>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Missionnmole;
